export const BG_FASHION_PREFIX = '';
export const PRODUCTS_PREFIX = '';

export enum BgFashionPath {
  Home = '',
  Product = 'product',
  Category = 'category',
  Subcategory = 'subcategory',
  Cart = 'cart',
  Favorites = 'favorites',
  Error = 'error',
}
